const KEY_ACCESS_TOKEN = process.env.REACT_APP_KEY_ACCESS_TOKEN;
const GOOGLE_ACCOUNT_CLIENT_ID = process.env.REACT_APP_GOOGLE_ACCOUNT_CLIENT_ID;

const HUB_HOST = process.env.REACT_APP_HUB_HOST;

export { KEY_ACCESS_TOKEN, HUB_HOST, GOOGLE_ACCOUNT_CLIENT_ID };
